import React from "react";
import { Box } from "@mui/material";

/** `[{label, value}]` as a real definition list (`confirmation.summary`, `summary.items`). */
export default function DefinitionList({ items = [] }) {
	return (
		<Box component="dl" sx={{ display: "grid", gridTemplateColumns: "auto 1fr", columnGap: 1.5, rowGap: 0.5, m: 0, fontSize: 12.5 }}>
			{items.map((item, i) => (
				<React.Fragment key={`${item.label}-${i}`}>
					<Box component="dt" sx={{ fontWeight: 500 }}>{item.label}</Box>
					<Box component="dd" sx={{ m: 0, overflowWrap: "anywhere" }}>{item.value}</Box>
				</React.Fragment>
			))}
		</Box>
	);
}
